import { FormLabel, forwardRef, Select, SelectProps } from '@chakra-ui/react';
import { PropsWithChildren, ReactNode } from 'react';
import { WithFormControl, WithFormControlProps } from '../WithFormControl';

export interface SelectFieldProps extends PropsWithChildren, SelectProps {
  label?: ReactNode;
  rootProps?: WithFormControlProps;
}

export const SelectField = forwardRef<SelectFieldProps, 'select'>(({ label, rootProps, children, ...props }, ref) => {
  return (
    <WithFormControl variant='floating' {...rootProps}>
      <Select variant='flushed' {...props} ref={ref}>
        {children}
      </Select>
      {label ? <FormLabel style={{ fontWeight: 'bold' }}>{label}</FormLabel> : null}
    </WithFormControl>
  );
});
